<template>
  <zt-modal
        :active="noLinkAccountModalActive"
        @close="closeModal"
        max-width="42rem"
        :z-index="200"
        :fullscreen="isMobile"
      >
        <template slot="modal-header">
          <div class="p-4 font-normal text-zt-lg text-center md:text-left">
            {{ $t('message.linkUser.noLinkAccountModal.modalTitle') }}
          </div>
        </template>
        <div class="p-10 text-center md:flex md:text-left">
          <div class="md:w-1/4">
            <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"></zt-icon>
          </div>
          <div class="md:w-3/4">
            <h1 class="text-bold text-xl mb-4  md:mb-3">
              {{ $t('message.linkUser.noLinkAccountModal.title') }}
            </h1>
            <div class="text-left">
              <p class=" text-zt-dark-500">{{ $t('message.linkUser.noLinkAccountModal.description') }}</p>
              <form action="reason-form">
                <div class="" v-for="(item, key) in values" :key="item.id">
                  <zt-radio-button
                    :id="key"
                    :value="item.id"
                    name="dev-names"
                    data-vs-radio-button="reasonsNotToLink"
                    v-model="reasonsNotToLink"
                  >
                    {{ item.value }}
                  </zt-radio-button>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div
          class="zt-modal-footer grey-background border-b flex p-5 fixed md:relative bottom-0 right-0 left-0 justify-end"
        >
          <div class="">
            <zt-button
              data-vs-button="cancel-button"
              class="ml-1 w-11/12"
              color="disabled" style="color: #707070 !important"
              @click="closeModal()"
              >{{ $t('message.linkUser.noLinkAccountModal.cancelBtn') }}</zt-button
            >
          </div>
          <div class="">
            <zt-button
              data-vs-button="go-link-user"
              class="ml-1 w-11/12"
              @click="goToLinkUserAccounts()"
              >{{ $t('message.linkUser.noLinkAccountModal.successOkBtn') }}</zt-button
            >
          </div>
        </div>
      </zt-modal>
    
  </template>

  <script>
  export default {
    name:'NoLinkAccountModal',
    props: {
      isMobile: {
        type: Boolean,
        default: false
      },
      noLinkAccountModalActive: {
        type: Boolean,
        default: false
      },
    },
    data() {
    return {
      reasonsNotToLink: null,
      values: [
        { id: 1, value: 'No quiero realizar la vinculación' },
        { id: 2, value: 'No soy propietario / Desconozco esta cuenta' },
      ],
    }
  },
    methods: {
      goToLinkUserAccounts() {
        this.$emit('notLinkAccount',this.reasonsNotToLink);
      },
      closeModal() {
        this.$emit('update:noLinkAccountModalActive', false);
      },
    }
}
</script>
<style scoped>
.grey-background {
  background-color:#ebebeb;
}
</style>